export function createJobSchedule() {
    return {
        is_active: true,
        period: { from: null, to: null },
        days_of_week: {
            is_monday: true,
            is_tuesday: true,
            is_wednesday: true,
            is_thursday: true,
            is_friday: true,
            is_saturday: true,
            is_sunday: true,
        },
        start_time: [null]
    }
}
